import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthProvider.js";
import clearStoredSession from "./clearStoredSession.js";

// Logout volontario: il BE revoca il refresh token e cancella il cookie, poi
// pulizia locale (onClear: stato dell'app) e /login. Se la chiamata fallisce
// la sessione resta com'e'.
const useLogout = ({ api, onClear } = {}) => {
  const { setAuth } = useAuth();
  const navigate = useNavigate();

  const logout = async () => {
    try {
      await api.get("/auth/logout", {
        withCredentials: true,
      });
      clearStoredSession(setAuth);
      onClear?.();
      navigate("/login");
    } catch (err) {
      console.error("logout failed", err?.response?.status);
    }
  };

  return logout;
};

export default useLogout;
